import Vue from "vue";
import ElementUiMoney from "vuetify-money";

Vue.use(ElementUiMoney);
export default ElementUiMoney;